import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OilSupplierService } from '../../openapi';
import { OilSupplierMutationKeys } from './constants';

export const useCreateOilSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [OilSupplierMutationKeys.CREATE_OIL_SUPPLIER],
    mutationFn: (data: any) =>
      OilSupplierService.oilSupplierControllerCreate(data),
  });
};
